document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll<HTMLElement>('[data-form-mode]');
  const formContainer = document.querySelector<HTMLElement>('[data-form-container]');
  const sections = document.querySelectorAll<HTMLElement>('[data-form-section]');
  const formModeInput = document.querySelector<HTMLInputElement>('#contact_form_formMode');

  const setFormMode = (mode: string) => {
    if (formModeInput) {
      formModeInput.value = mode;
    }

    if (formContainer) {
      formContainer.hidden = false;
    }

    buttons.forEach((button) => {
      button.classList.toggle(
        'button--default',
        button.dataset.formMode === mode,
      );
      button.classList.toggle(
        'button--outline',
        button.dataset.formMode !== mode,
      );
    });

    sections.forEach((section) => {
      section.hidden = section.dataset.formSection !== mode;
    });
  };

  sections.forEach((section) => {
    section.hidden = true;
  });

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const mode = button.dataset.formMode;
      console.log('mode', mode);
      if (mode) {
        setFormMode(mode);
      }
    });
  });
});